export const getProductMicrodata = (
  {
    title,
    productUrl,
    imageUrl,
    availability,
    price,
    reviewRating,
    reviewAuthor,
    reviewCount,
    ratingValue,
    characteristics
  }) => {
  return {
    '@type': 'Product',
    'name': title,
    'url': productUrl,
    'image': imageUrl,
    'brand': {
      '@type': 'Brand',
      'name': 'Dnipro-m'
    },
    'offers': {
      '@type': 'Offer',
      'availability': availability ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock',
      'price': price.toFixed(2),
      'priceCurrency': window.config.currency.currency_code || 'PLN',
      'seller': {
        '@type': 'Organization',
        'name': 'Dnipro‑m'
      },
      'shippingDetails': {
        '@type': 'OfferShippingDetails',
        'shippingDestination': {
          '@type': 'DefinedRegion',
          'addressCountry': 'PL'
        },
        'shippingRate': {
          '@type': 'MonetaryAmount',
          'value': 0,
          'currency': 'PLN'
        },
        'deliveryTime': {
          '@type': 'ShippingDeliveryTime',
          'handlingTime': {
            '@type': 'QuantitativeValue',
            'minValue': 0,
            'maxValue': 1,
            'unitCode': 'DAY'
          },
          'transitTime': {
            '@type': 'QuantitativeValue',
            'minValue': 0,
            'maxValue': 3,
            'unitCode': 'DAY'
          }
        }
      },
      'hasMerchantReturnPolicy': {
        '@type': 'MerchantReturnPolicy',
        'applicableCountry': ['PL'],
        'returnPolicyCategory': 'MerchantReturnFiniteReturnWindow',
        'merchantReturnDays': 30,
        'returnShippingFeesAmount': {
          '@type': 'MonetaryAmount',
          'value': 0,
          'currency': 'PLN'
        },
        'returnFees': 'FreeReturn',
        'returnMethod': 'ReturnByMail'
      }
    },
    'review': reviewRating ? {
      '@type': 'Review',
      'reviewRating': {
        '@type': 'Rating',
        'ratingValue': reviewRating,
        'bestRating': 5
      },
      'author': reviewAuthor ? {
        '@type': 'Person',
        'name': reviewAuthor
      } : undefined
    } : undefined,
    'aggregateRating': reviewCount ? {
      '@type': 'AggregateRating',
      'ratingValue': ratingValue || 5,
      'reviewCount': reviewCount
    } : undefined,
    'additionalProperty': characteristics && characteristics.length ? characteristics.map(characteristic => {
      return {
        '@type': 'PropertyValue',
        'name': characteristic.name,
        'value': characteristic.value
      }
    }) : undefined
  }
}
